import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoryViewComponent } from './history-view.component';
import { StoryMediaPickerComponent } from './story-media-picker.component';
import { IonicModule } from '@ionic/angular';



@NgModule({
    declarations: [
        HistoryViewComponent,
        StoryMediaPickerComponent
    ],
    exports: [
        HistoryViewComponent
    ],
    imports: [
        CommonModule,
        IonicModule
    ]
})
export class HistoryViewModule { }
